/**
 *
 * Load CS
 *
 * UI that handles the functionality of showing individual Case Studies
 */

const $ = require('jquery');
require("@babel/polyfill");
const Masonry = require('masonry-layout');
const Highlight = require('highlight.js');

var LoadCS = function (el) {

  //setup some variables
  //body elements
  this.$el = $(el);
  this.$document = $(document);
  
  this.$body                = this.$document.find('body');
  this.$caseStudyWrap       = this.$document.find('#itbl-c-customers-new__case-study-wrap');
  this.$closeCaseStudy      = this.$document.find('#itbl-case-study--closed a');
  this.$content             = this.$document.find('#content');
  this.$defaultCaseStudy    = this.$document.find('#default-case-study');
  this.$defaultCaseStudyCTA = this.$document.find('.js-load-case-study');
  this.$mainWrapper         = this.$document.find('#itbl-customers-wrapper').get(0);
  this.$stickyLogos         = this.$document.find( '.itbl-c-customers-new__customers' );
  this.$wrapperInner        = this.$document.find('.itbl-c-customers-new__inner');


  //elements related to the customer container
  this.$caseStudyCTA     = this.$el.find('.itbl-c-customer-new__cta.cta--cs');
  this.$caseStudyCTAWrap  = this.$el.find('.itbl-c-customers-new__logo-CTA--cs');
  this.$videoCTA       = this.$el.find('.itbl-c-customer-new__cta.cta--video');
  this.$videoCTAWrap    = this.$el.find('.itbl-c-customers-new__logo-CTA--video');

  //error Elements
  this.$error       = this.$document.find('#itbl-c-customers--error');
  this.$errorCTA       = this.$error.find('.itbl-c-customers--error-reload');

  this.$caseStudyParent   = this.$caseStudyWrap.parent();
  this.$customersParent   = this.$el.parent();

  //setup initial values for the current case study
  //state management

  this.currentCustomer     = null;
  this.currentPostId       = null;
  this.currentElId       = null;
  this.currentCustomerName   = null;
  this.caseStudyIsVisible   = false;
  this.errorRetryCTA       = null;
  this.ajaxCall        = null;
  this.currentCustomerId = null;

  this.currentCustomerId = this.$content.data('page-id');
  this.currentCustomerId = 'customer-' + this.currentCustomerId;
  this.currentCustomer = this.$el.find(`#${this.currentCustomerId}`);

  this.init();

};

LoadCS.prototype.init = function () {

  this.initStickyLogos();

  this.events();

  // wait for document to be ready, then scroll to parent

  this.$document.ready( () => {
    this.scrollToParent(this.$stickyLogos, this.currentCustomer);
  });

  //show the default case study
  this.$defaultCaseStudy
    .removeClass('case-study--hidden')
    .addClass('case-study--visible');

};

LoadCS.prototype.events = function () {

  this.$videoCTA.on('click', this.event__playVideo.bind(this));
  this.$videoCTAWrap.on('click', this.event__playVideo.bind(this));
  this.$closeCaseStudy.on('click', this.event__toggleCaseStudy.bind(this));
  this.$defaultCaseStudyCTA.on('click', this.event__defaultTriggerCaseStudy.bind(this) );

};

LoadCS.prototype.event__defaultTriggerCaseStudy = function(event){

  event.preventDefault();

  const $post = $(event.currentTarget);
  const href = $post.attr('href');

  $(href).click();

};

LoadCS.prototype.initStickyLogos = function(){

  const config = {
    threshold: [0,1]
  };

  const handler = (entries) => {

    entries.forEach( (entry)=>{

      if( entry.intersectionRatio === 0){
        this.$stickyLogos.css({
          top: '30px'
        });
      }else if( entry.intersectionRatio === 1 ){
        this.$stickyLogos.css({
          top : 0
        });
      }

    } );

  };

  // create the observer
  if (typeof window.IntersectionObserver !== 'undefined') {
    const observer = new window.IntersectionObserver(handler, config );
    // give the observer some dom nodes to keep an eye on
    observer.observe(document.querySelector('#itbl-c-customers-new__hero'));
  }
};

LoadCS.prototype.event__handleErrorRetry = function (event) {

  event.preventDefault();

  this.loadCS();

};

LoadCS.prototype.event__handleMobileSwipe = function (event) {

  if (!Foundation.MediaQuery.atLeast('medium')) {
    this.$wrapperInner.removeClass('case-study-is-visible');
  }

};

LoadCS.prototype.event__playVideo = function (event) {

  event.preventDefault();
  let $post = $(event.currentTarget);

  //open fancybox
  window.jQuery.fancybox.open({
    src: $post.attr('href'), // Source of the content
  });

  //update the hash
  if (history.pushState) {
    history.pushState(null, null, `/${$post.attr('id')}`);
  } else {
    location.hash = `#${$post.attr('id')}`;
  }


};

LoadCS.prototype.event__toggleCaseStudy = function (event) {

  //if this is an event then we need to close
  //else, this is to turn on the case study
  if (event && typeof event !== 'undefined') {
    event.preventDefault();

    this.$body.removeClass('itbl-body-case-study-active');
    this.$wrapperInner.removeClass('case-study-is-visible');
  } else {
    this.$wrapperInner.addClass('case-study-is-visible');
    this.$body.addClass('itbl-body-case-study-active');

    $('.js-scroll-container')
    .animate({
      scrollTop: 0
    }, 1000);
  }

};

LoadCS.prototype.triggerMobileView = function (event) {

  let swipeDirection = null;

  if (typeof event !== 'undefined') {
    swipeDirection = event.direction;
  }

  if (Foundation.MediaQuery.atLeast('large')) {
    return;
  }

  switch (swipeDirection) {

    //swipe to the left
    case 2:

      if (this.$wrapperInner.hasClass('case-study-is-visible')) {

        this.$wrapperInner.removeClass('case-study-is-visible');
      }

      break;

    //swipe to the right
    case 4:
    default:
      if (!this.$wrapperInner.hasClass('case-study-is-visible')) {
        this.$wrapperInner.addClass('case-study-is-visible');
      }


  }


};

LoadCS.prototype.scrollToParent = function ($parentEl, $offsetEl) {

  if (!$offsetEl || !$offsetEl.offset || typeof $offsetEl.offset() === 'undefined') {
    $parentEl.animate({ scrollTop: 0 }, 1000);
    return;
  }

  const offsetElTop = $offsetEl.offset().top
  const parentElTop = ($parentEl.offset() || { top: 0 }).top
  const parentElScrolltop = $parentEl.scrollTop() || 0;

  console.log(offsetElTop, parentElTop, parentElScrolltop);

  //scroll to the customer parent
  $parentEl
    .animate({
      scrollTop: (offsetElTop - parentElTop + parentElScrolltop) - 100
    }, 1000);

};

$(document).on( 'ajaxInit', function(){

  // Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
      $(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      $(this).wrap("<div class='responsive-embed'/>");
    }
  });

}).ready( () => {

  $('#customers-logos').each( function() {
    new LoadCS(this);

    new Masonry($(this).find('[data-component=customers-logos-masonry-container]')[0], {
      itemSelector: '[data-component=customer-masonry-card]',
      columnWidth: '[data-component=customer-masonry-card]',
    });
  });

} );


window.Masonry = Masonry;

window.Highlight = Highlight;
